import { ProductIDs } from './base';

export const SwitchYourMatesIDs = {
  PowerHouse: 'PH0525-SYM-75',
  PowerOffset: 'PO-SYM-75',
  PowerBusiness: 'PB-SYM-75',
  SwitchSaver: 'SYM-SWS-275-digital',
  EVDay: 'EVD-SYM-75',
  EVNight: 'EVN-SYM-75',
  EVDaySaver: 'EVDS-SYM-175-0225',
  EVNightSaver: 'EVNS-SYM-175',
} as const;

export type SwitchYourMatesIDValues =
  (typeof SwitchYourMatesIDs)[keyof typeof SwitchYourMatesIDs];

// Excludes products that do not have a SYM promo
export type SwitchYourMatesValidIDs = Exclude<
  ProductIDs,
  typeof ProductIDs.GasPowerHouse | typeof ProductIDs.GasPowerOffset
>;

export const SwitchYourMatesPlanIDMapping: Record<
  SwitchYourMatesValidIDs,
  SwitchYourMatesIDValues | undefined
> = {
  [ProductIDs.SwitchSaver]: SwitchYourMatesIDs.SwitchSaver,
  [ProductIDs.PowerHouse]: SwitchYourMatesIDs.PowerHouse,
  [ProductIDs.PowerBusiness]: SwitchYourMatesIDs.PowerBusiness,
  [ProductIDs.PowerOffset]: SwitchYourMatesIDs.PowerOffset,
  [ProductIDs.PowerDrive]: SwitchYourMatesIDs.EVNight,
  [ProductIDs.PowerDriveDay]: SwitchYourMatesIDs.EVDay,
  [ProductIDs.EVDaySaver]: SwitchYourMatesIDs.EVDaySaver,
  [ProductIDs.EVNightSaver]: SwitchYourMatesIDs.EVNightSaver,
};
